import _typeof from "@babel/runtime/helpers/typeof";
export var isPrimitive = function isPrimitive(value) {
  return value !== Object(value);
};
export var isFunction = function isFunction(fn) {
  return typeof fn === 'function';
};
export var callIfFunction = function callIfFunction(fn) {
  if (isFunction(fn)) {
    fn();
  }
};
export var isObject = function isObject(item) {
  return item && _typeof(item) === 'object' && !Array.isArray(item);
};